import { All as Other } from 'ui/svg/icons/venueAndCategories/All'
import { ArtMaterial } from 'ui/svg/icons/venueAndCategories/ArtMaterial'
import { Book as Library } from 'ui/svg/icons/venueAndCategories/Book'
import { Bookstore } from 'ui/svg/icons/venueAndCategories/Bookstore'
import { Castle as HeritageSite } from 'ui/svg/icons/venueAndCategories/Castle'
import { Cinema } from 'ui/svg/icons/venueAndCategories/Cinema'
import { CulturalCentre } from 'ui/svg/icons/venueAndCategories/CulturalCentre'
import { Festival } from 'ui/svg/icons/venueAndCategories/Festival'
import { Landscape as ArtGallery } from 'ui/svg/icons/venueAndCategories/Landscape'
import { Museum } from 'ui/svg/icons/venueAndCategories/Museum'
import { Opera } from 'ui/svg/icons/venueAndCategories/Opera'
import { PerformingArts } from 'ui/svg/icons/venueAndCategories/PerformingArts'
import { Piano as MusicInstrumentStore } from 'ui/svg/icons/venueAndCategories/Piano'
import { Store } from 'ui/svg/icons/venueAndCategories/Store'
import { Turntable as RecordStore } from 'ui/svg/icons/venueAndCategories/Turntable'

export const activityIcons = {
  ArtMaterial,
  Bookstore,
  Cinema,
  CulturalCentre,
  Festival,
  Library,
  Museum,
  MusicInstrumentStore,
  Opera,
  Other,
  HeritageSite,
  PerformingArts,
  RecordStore,
  Store,
  ArtGallery,
}
